{
  "ascending": "crescente",
  "ascendingSort": "classificado pela coluna {columnName} em ordem crescente",
  "columnSize": "{value} pixels",
  "descending": "decrescente",
  "descendingSort": "classificado pela coluna {columnName} em ordem decrescente",
  "resizerDescription": "Pressione Enter para começar a redimensionar",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "coluna classificável",
  "collapse": "Recolher",
  "expand": "Expandir"
}
